import { get } from './common';
import { ContainerData, LegacyApiContainer } from '../Types/containerV2';

const containerEndpoint = 'api/container';

export async function getAdminContainer(containerId: number): Promise<ContainerData> {
	const result = await get<ContainerData>(`${containerEndpoint}/GetAdminContainer?id=${containerId}`);
	if (!result) throw new Error('Failed to load container.');
	return result;
}

/**
 * Response from the backend container API.
 * The backend currently returns a ContainerVersion object that wraps the container.
 * When a V2 API is introduced, it may return ContainerData directly.
 */
export type ContainerApiResponse = {
	/** Present when the response is from the legacy API (ContainerVersion). */
	Container?: LegacyApiContainer;
	/** Future: direct V2 format. */
	container?: LegacyApiContainer;
	/** Version indicator for future-proofing. */
	version?: number;
};

/**
 * Fetches a container by its ID from the backend.
 */
export async function getContainer(containerId: number): Promise<ContainerApiResponse> {
	const endpoint = `${containerEndpoint}/GetContainer?id=${containerId}`;
	const result = await get<LegacyApiContainer>(endpoint);
	return { Container: result! };
}
